<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">软件更新</div>
          <div class="card-body">
            <div class="auth" :class="{'min-150':loading}">
              <Spin fix v-if="loading">
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>正在检测新版本</div>
              </Spin>
              <div v-else>


                <div class="title" v-if="data.version == version">
                  <Icon type="md-thumbs-up" color="#ff5473" />
                  当前已是最新版啦</div>
                <div class="title" v-else> 发现新版本啦</div>
                <div class="version"> 当前程序版本：{{version}} </div>
                <div class="version"> 最新程序版本：{{data.version}} （{{data.time}}） </div>
                <p style="margin-top:5px" v-if="data.version != version" v-html="data.v3explain"></p>
              </div>

            </div>
            <Divider />
            <div class="auth">

              <Button type="primary" @click="modal = true">更新数据</Button>
              <p style="font-size: 12px; color: #999;margin-top:10px">
                * 每次更新完版本之后都需要点此按钮进行数据库新功能字段更新，如无特殊说明不会影响当前数据；若更新失败请自行访问 "域名/admin/home/update" 手动更新
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
    <Modal v-model="modal" title="数据库更新" class-name="vertical-center-modal" footer-hide>
      <iframe src="/admin/home/update" frameborder="0"></iframe>
    </Modal>
  </div>
</template>

<script>
  import {
    getUpdate
  } from "@/api/admin";
  import {
    mapState,
  } from 'vuex'
  export default {
    data() {
      return {
        data: {},
        title: "",
        loading: true,
        modal: false
      };
    },
    computed: {
      ...mapState(['version']),
    },
    created() {
      console.log(this.version)
      this._getData();
    },

    methods: {
      // 获取列表
      _getData() {
        getUpdate().then((res) => {
          this.data = res.data;
          this.loading = false
        });
      },


    },
  };
</script>

<style lang="less" scoped>
  iframe {
    width: 100%;
    min-height: 200px;
  }

  .auth {
    padding: 12px;
    background-color: #fff;
    border: 1px solid #f7f7f7;
    border-left: 4px solid #339fd4;
    border-radius: 5px;
    position: relative;
    margin-bottom: 20px;

    .title {
      color: #ff5473;
      font-weight: 600;
      font-size: 18px;
    }

    .version {
      line-height: 40px;
    }

    .btn {
      margin: 10px 0;
    }
  }

  .min-150 {
    min-height: 150px;
  }
</style>